import type { OAISchema } from '~/types/openapi';

type InquiryType = OAISchema['MarketPlaceProductInquiryResponse']['type'];
export const INQUIRY_TYPE: Record<InquiryType, string> = {
  DELIVERY: '배송문의',
  ETC: '기타',
  PRODUCT: '상품문의',
  RESTOCK: '재입고문의',
};
type InquiryStatus = OAISchema['MarketPlaceProductInquiryResponse']['status'];
export const INQUIRY_STATUS: Record<InquiryStatus, string> = {
  ANSWERED: '답변완료',
  DELETED: '삭제됨',
  PENDING: '답변대기',
};
